import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AlertService {

  constructor(private toastr: ToastrService) { }

  showSuccessMessage(mensagem: string | null | undefined = null) {
    this.toastr.success(mensagem || 'Dados Salvos com Sucesso!');
  }

  showErrorMessage(mensagem: string | null | undefined = null) {
    this.toastr.error(mensagem || 'Algum erro ocorreu!');
  }

  showWarningMessage(mensagem: string | null | undefined = null) {
    this.toastr.warning(mensagem || 'Algum erro ocorreu!');
  }
}